import { Button, Grid, styled, Typography } from "@mui/material"
import NoInternet from "src/assets/icons/nointernet.svg"
import { blueGrey } from "@mui/material/colors"
import SvgIcon from "src/shared/components/SvgIcon"

const MainContainer = styled(Grid)(() => ({
  textAlign: "center",
  minHeight: "100vh",
  padding: "12px 24px",
  backgroundColor: "white"
}))

const Title = styled(Typography)({ color: blueGrey[500], fontSize: 28, fontWeight: 600 })

const Subtitle = styled(Typography)({ color: blueGrey[500] })

const RetryButton = styled(Button)({ backgroundColor: blueGrey[500], color: "white", marginTop: 12 })

function Offline({ retry }: { retry: () => void }) {
  return (
    <MainContainer container alignItems="center" justifyContent="center" direction="column">
      <Grid size={{ md: 6, xs: 12 }}>
        <SvgIcon size="140px" src={NoInternet} />
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <Title fontWeight="bold" fontSize={24}>
          Seems like you are disconnected.
        </Title>
        <Subtitle variant="body1" fontSize={16}>
          Please check your internet connection and try again.
        </Subtitle>
        <RetryButton
          size="medium"
          variant="contained"
          onClick={() => {
            retry()
            window.location.reload()
          }}
        >
          Retry Again
        </RetryButton>
      </Grid>
    </MainContainer>
  )
}

export default Offline
